const statBoxes = [{
    name: "Pendientes",
    stat: 0,
    color: "text-gray-500",
    comando: "Pendiente",
  },
  {
    name: "Presentes",
    stat: 0,
    color: "text-green-500",
    comando: "Presente",
  },
  { name: "Ausentes", stat: 0, color: "text-red-500", comando: "Ausente" },
  { name: "Tarde", stat: 0, color: "text-yellow-500", comando: "Tarde" },];

  const columns = [
    { name: "Carnet", id: 0, type: "text", resaltado: false },
    { name: "Nombre", id: 1, type: "text", resaltado: false },
    { name: "Fecha", id: 3, type: "text", resaltado: false },
    { name: "Faltas", id: 7,    type: "asistencia", resaltado: false, text:"   " , color:"red-500"},
    { name: "Tarde", id: 8,     type: "asistencia", resaltado: false, text:"   " , color:"orange-400"},
    { name: "Pendiente", id: 9, type: "asistencia", resaltado: false, text:"   " , color:"gray-400"},
  ];

  const columnTypes = [
    { name: "Carnet", id: 1, type: "text", resaltado: false },
    { name: "Nombre", id: 23, type: "text", resaltado: false },
    {
      name: "Quitar",
      id: 999,
      type: "text",
      resaltado: false,
      text: "     ",
    },
  ]
  export {
    statBoxes, columns, columnTypes,
  }